import React from 'react';
import { google, outlook, yahoo } from 'calendar-link';
import { T } from '@tribeplatform/react-components/i18n';
import { Dropdown } from '@tribeplatform/react-ui-kit/Dropdown';
import { CalendarItemComponent } from './CalendarItemComponent.js';
import { DOWNLOAD_ICON, GOOGLE_ICON, WINDOWS_ICON, YAHOO_ICON, } from './icons.js';
import { CalendarType, } from './types.js';
import { parseJSON } from './utils.js';
export const AddToCalendarButtonBlock = ({ event, }) => {
    if (!event) {
        return null;
    }
    const eventObject = Object.assign({}, parseJSON(event));
    const cleanEvent = Object.assign(Object.assign(Object.assign({}, eventObject), { start: (eventObject === null || eventObject === void 0 ? void 0 : eventObject.start)
            ? new Date(eventObject.start).toUTCString()
            : new Date().toUTCString() }), (!!(eventObject === null || eventObject === void 0 ? void 0 : eventObject.end) && {
        end: new Date(eventObject.end).toUTCString(),
    }));
    const calendarItems = [
        {
            name: 'Google',
            type: CalendarType.GOOGLE,
            url: google(cleanEvent),
            icon: GOOGLE_ICON,
        },
        {
            name: 'Yahoo',
            type: CalendarType.YAHOO,
            url: yahoo(cleanEvent),
            icon: YAHOO_ICON,
        },
        {
            name: 'Outlook',
            type: CalendarType.OUTLOOK,
            url: outlook(cleanEvent),
            icon: WINDOWS_ICON,
        },
        {
            name: 'Download ics file',
            type: CalendarType.ICS,
            icon: DOWNLOAD_ICON,
        },
    ];
    return (React.createElement(Dropdown, { placement: "bottom-start" },
        React.createElement(Dropdown.ButtonMinimal, { as: "button" },
            React.createElement("span", { className: "px-1 text-interactive hover:text-interactive-hovered" },
                React.createElement(T, { defaultMessage: "Add to calendar", id: "AddToCalendarButtonBlock.AddToCalendar" }))),
        React.createElement(Dropdown.Items, null, calendarItems.map((actionItem) => (React.createElement(CalendarItemComponent, { key: actionItem.name, actionItem: actionItem, event: cleanEvent }))))));
};
//# sourceMappingURL=Block.js.map